import { BaseWalletAdapter } from './adapter';
export class BaseSignerWalletAdapter extends BaseWalletAdapter {
}
export class BaseMessageSignerWalletAdapter extends BaseSignerWalletAdapter {
}
//# sourceMappingURL=signer.js.map